<template>
  <div class="footer-container">
    
    <el-row class="center-box">

      <el-col :xs="12"
              :sm="6"
              :md="6"
              :lg="6"
              :xl="6"
              class="logo-col">
        <div class="left-box">
          <span class="left-title">{{$t('aboutus')}}</span>
          <img src="../assets/logo.png"/>
          <div class="logo-box">
            <img src="../assets/linkin.png" @click="jumpLinkin" class="linkin-img"/>
            <!-- <el-popover
              placement="top"
              trigger="hover"
              popper-class="poper-box"
            >
              <img src="../assets/logo.png" class="qrcode"/> -->
              <img src="../assets/wechat.png" slot="reference" class="wechat"/>
            <!-- </el-popover> -->
            <img src="../assets/twitter.png" @click="jumpTwitter" class="linkin-img"/>
            <img src="../assets/facebook.png" @click="jumpFacebook" class="linkin-img"/>
          </div>
        </div>
      </el-col>

      <el-col :xs="12"
              :sm="6"
              :md="6"
              :lg="6"
              :xl="6"
              class="content-left-col">
        <div class="content-box">
          <span class="content-title">{{$t('solution')}}</span>
          <!-- <span class="content-item">{{$t('customizationSolution')}}</span>
          <span class="content-item">{{$t('intelligentDecision')}}</span> -->
        </div>
      </el-col>

      <el-col :xs="12"
              :sm="6"
              :md="6"
              :lg="6"
              :xl="6"
              class="content-col">
        <div class="content-box">
          <span class="content-title">{{$t('productIntroduce')}}</span>
          <router-link class="content-item item-link" to="/modao">{{$t('modaoSolution')}}</router-link>
          <router-link class="content-item item-link" to="/mohe">{{$t('moheSolution')}}</router-link>
          <router-link class="content-item item-link" to="/business">{{$t('businessCop')}}</router-link>
        </div>
      </el-col>

      <el-col :xs="12"
              :sm="6"
              :md="6"
              :lg="6"
              :xl="6"
              class="content-right-col">
        <div class="content-box">
          <span class="content-title">{{$t('aboutus')}}</span>
          <router-link class="content-item item-link" to="/introduce">{{$t('introduceCom')}}</router-link>
          <router-link class="content-item item-link" to="/joinus">{{$t('joinUs')}}</router-link>
        </div>
      </el-col>
    </el-row>

    <p class="bottom-text">This site is protected by re CAPTCHA and the Google Privacy Policy and Terms of Service apply.</p>
  </div>
</template>

<script>
export default {

  methods: {

    jumpLinkin(){
      window.open('https://www.linkedin.com/company/mopan-pte-ltd/?viewAsMember=true');
    },

    jumpTwitter(){
      window.open('https://twitter.com/Ltdmopan');
    },

    jumpFacebook(){
      window.open('https://www.facebook.com/mopan-Pte-Ltd-107898250959005/?modal=admin_todo_tour');
    }

  }
  
}
</script>

<style lang="less" scoped>

.footer-container{
  position: relative;
  width: 100%;
  height: 355px;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background: url("../assets/bottom_bg.png") no-repeat center center;
  background-size: 100% 100%;

}

.logo-col{
  display: flex;
  justify-content: flex-end;

  .left-box{
    display: flex;
    flex-direction: column;
    font-size: 20px; 
    // margin-left:50px;
    // margin-top: 75px;
    // margin-bottom: 75px;
    // justify-content: space-between;
    align-items: center;
    width: 200px;

    img{
      width: 70px;
      height: 70px;
      margin: 30px auto;
    }

    .linkin-img{
      cursor: pointer;
    }

    .logo-box{
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      img{
        width: 50px;
        height: 50px;
        margin: 0 20px 0;
      }

      // .wechat:hover{
      //   content: url('../assets/wechat_light.png');
      // }

    }
  }
}

.poper-box{
  .qrcode{
    width: 120px !important;
    height: 120px !important; 
    display: block;
    margin: auto;
  }
}

.center-box{
  // display: flex;
  // flex-direction: row;
  margin-top: 70px;
  // margin-right: 130px;
  width: 100%;
  // align-items: center;

  .content-left-col{
    display: flex;
    justify-content: flex-end;
  }
  .content-col{
    display: flex;
    // align-items: center;
    justify-content: center;
  }

  .content-box{
    display: flex;
    flex-direction: column;
    text-align: left;

    justify-content: center;
    align-content: center;
    // margin-right: 120px;

    .content-title{
      font-size: 25px; 
      margin-bottom: 35px;
    }

    .content-item{
      font-size: 16px; 
      margin-bottom: 20px;
    }

    .item-link{
      color: white;
      text-decoration: none;

      &:hover{
        color: #448DFF;
      }
    }
  }
}

.bottom-text{
  font-size: 15px; /*px*/
  position: absolute;
  bottom: 50px;
  text-align: center;
  margin: 0 auto;
  left: 0;
  right: 0;
}

@media only screen and (max-width: 768px) {
  
  .footer-container {
    height: 300px; /*no*/

    .logo-col{
      justify-content: center;
      height: 100px;/*no*/
      align-items: center;
      padding-right: 200px;
      .left-box{
          display: flex;
          flex-direction: column;
          font-size: 10px; /*no*/
          align-items: center;

          .left-title{
            width: 100px; /*no*/
          }

          img{
            width: 30px;/*no*/
            height: 30px;/*no*/
            margin: 10px auto;/*no*/
          }

          .logo-box{
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            img{
              width: 20px;/*no*/
              height: 20px;/*no*/
              margin: 0 5px 0;/*no*/
            }

            .wechat:hover{
              content: url('../assets/wechat_light.png');
            }
          }
        }
    }

    .center-box{

      .content-left-col {
        justify-content: flex-start;
        height: 120px;/*no*/
      }   
      .content-col{
        justify-content: center;
        height: 120px;/*no*/
        align-items: flex-start;
      }
      .content-right-col{
        display: flex;
        justify-content: flex-start;
        height: 120px;/*no*/
        align-items: flex-start;
      }

    }

    .content-box{
      // display: flex;
      // flex-direction: column;
      // text-align: left;

      // justify-content: center;
      // align-content: center;
      // margin-right: 120px;

      .content-title{
        font-size: 15px; /*no*/
        margin-bottom: 15px;/*no*/
      }

      .content-item{
        font-size: 8px; /*no*/
        margin-bottom: 10px;/*no*/
      }

      .item-link{
        color: white;
        text-decoration: none;

        &:hover{
          color: #448DFF;
        }
      }
    }

  }

  .poper-box{
    .qrcode{
      width: 50px !important;/*no*/
      height: 50px !important; /*no*/
    }
  }

}

</style>


// WEBPACK FOOTER //
// src/components/Footer.vue